import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

const strengthLabels = {
  0: 'Very weak',
  1: 'Weak',
  2: 'Okay',
  3: 'Moderate',
  4: 'Strong',
};

const PasswordStrength = ({ score }) => {
  if (score == null) {
    return null;
  }

  return (
    <div className="d-flex align-items-center mt-1">
      <ProgressBar now={(score * 100) / 4} className="flex-grow-1" />
      <div className="ml-3 text-right" style={{ minWidth: '5em' }}>
        <span className="sr-only">Password strength:</span>
        {strengthLabels[score] || 'Strong'}
      </div>
    </div>
  );
};

export default PasswordStrength;
